<ul>
    <ng-container *ngFor="let year of years; index as i">
        <li
            *ngIf="i >= startIndex && i <= stopIndex"
            [ngClass]="{
                past: !year.isEstimated,
                selected: year.year === selectedYear
            }"
            (click)="onSelectYear(year.year)">

            <app-gauge class="gauge-component"
                [value]="setGaugeValue(year.kpis)"
                [strokeWidth]="8"></app-gauge>
            <span class="label">{{year.year}}</span>
        </li>
    </ng-container>
</ul>
